export const homeObjOne = {
  headline: "ژانر فانتزی",
  description:
    " گونه‌ای هنری است که جادو و دیگر اَشکال فراطبیعی را به عنوان عنصر اولیهٔ طرح و توطئه، درون‌مایه یا فضای داستان استفاده می‌کند. این‌گونه معمولاً توسط نگاه، حس و درون‌مایهٔ وسیع از کار اشخاص از گونه‌های علمی‌تخیلی و وحشت متمایز می‌شود، هر چند که این سه گونه نقاط مشترک بسیاری با هم دارند و مجموعاً ادبیات گمانه‌زن ∗ شناخته می‌شوند. در خیال‌پردازی قواعد و قوانین فیزیکی و طبیعی زیر پا گذاشته می‌شود و موجودات ناموجود تصویر می‌شوند. این نوع ادبی معمولاً شامل سحر و جادو، حوادث خارق‌العاده، و موجودات خیالی است.",
  imgStart: "",
  img: require("./images/hero.png").default,
  alt: "تصویر کتاب فانتزی",
  start: "",
};
